module.exports = __webpack_public_path__ + "img/AQ-Team-2021.a0b3c7fc.jpg";